export default "__VITE_ASSET__cb6fdb0e__"